import { render, staticRenderFns } from "./editPlusRecord.vue?vue&type=template&id=f9967748&scoped=true&"
import script from "./editPlusRecord.vue?vue&type=script&lang=js&"
export * from "./editPlusRecord.vue?vue&type=script&lang=js&"
import style0 from "./editPlusRecord.vue?vue&type=style&index=0&id=f9967748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9967748",
  null
  
)

export default component.exports